const AUTH0_CACHE_PREFIX = '@@auth0spajs@@';

const authSessionCache = {
    get(key) {
        const value = sessionStorage.getItem(key);
        if (!value) {
            return undefined;
        }

        try {
            return JSON.parse(value);
        } catch (error) {
            sessionStorage.removeItem(key);
            return undefined;
        }
    },

    set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    },

    remove(key) {
        sessionStorage.removeItem(key);
    },

    allKeys() {
        return Object.keys(sessionStorage)
            .filter((key) => key.startsWith(AUTH0_CACHE_PREFIX));
    },
};

export default authSessionCache;
